import React from 'react'
import Logo from '../assets/logo1.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className='pt-5 pb-3'>
        <div className='container'>

<img src={Logo} className='footer-logo rounded-pill' alt='Footer Logo' />

<div className='row'>

<div className='col-lg-6 col-12 my-2'>

<div className='d-md-flex justify-content-around text-muted my-3 fm-spartan' style={{fontSize: '1.1em'}}>
  <p>9938888882<br />siddhabhairabi@gmail.com</p>
  <p>Sankarpur Street,<br />Berhampur, Ganjam, Odisha, 760006</p>
</div>
{/* flex ends */}
  <p className='text-muted fm-spartan'>&copy; Siddha Bhairabi Store. All Right Reserved. Developed By&nbsp;&nbsp;
    <Link className='footer-text' to='https://www.digithack.in/' target='_blank'>Digit Hack Software Solutions</Link>
  </p>

</div>


<div className='col-lg-6 d-flex'>
<div>
<p><Link className='footer-text' to='/'>Home</Link></p>
<p><Link className='footer-text' to='/about'>About</Link></p>
</div>
<div className='ms-3'>
<p><Link className='footer-text' to='/contact'>Contact</Link></p>
<p><Link className='footer-text' to='/privacy-policy'>Privacy Policy</Link></p></div>
</div>

{/* <div className='col-lg-3'>
</div> */}


</div>
{/* row ends */}


        </div>
      </footer>
    </>
  )
}

export default Footer
